export var defaultProps = {
    title: '',
    content: '',
    close: false,
    showIcon: false,
    type: 'info',
    hasBorder: true,
    onBeforeClose: function () { return true; },
    onClose: function () { },
};
